import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { BackIcon } from '../components/shared_icons/AppIcons';
import { useLoginBodyPortalTarget } from './LoginBody';
import loginStyles from '../../../stylesheets/components/login.module.scss';

interface LoginBackButtonPortalProps {
  to: string;
}

const LoginBackButtonPortal = ({ to }: LoginBackButtonPortalProps) => {
  const navigate = useNavigate();
  const portalTarget = useLoginBodyPortalTarget();

  if (!portalTarget) return null;

  return createPortal(
    <button
      className={loginStyles.loginBackButton}
      onClick={() => navigate(to)}
      type="button"
    >
      <BackIcon />
    </button>,
    portalTarget
  );
};

export default LoginBackButtonPortal;
